export const GET_DRAFTS_REQUEST = 'LAB.COURSE_VIEW.GET_DRAFTS_REQUEST';
export const GET_DRAFTS_SUCCESS = 'LAB.COURSE_VIEW.GET_DRAFTS_SUCCESS';
export const GET_DRAFTS_ERROR = 'LAB.COURSE_VIEW.GET_DRAFTS_ERROR';

export const GET_COMPLETED_LESSONS_REQUEST = 'LAB.COURSE_VIEW.GET_COMPLETED_LESSONS_REQUEST';
export const GET_COMPLETED_LESSONS_SUCCESS = 'LAB.COURSE_VIEW.GET_COMPLETED_LESSONS_SUCCESS';
export const GET_COMPLETED_LESSONS_ERROR = 'LAB.COURSE_VIEW.GET_COMPLETED_LESSONS_ERROR';

export const GET_ACTIVE_LESSONS_REQUEST = 'LAB.COURSE_VIEW.GET_ACTIVE_LESSONS_REQUEST';
export const GET_ACTIVE_LESSONS_SUCCESS = 'LAB.COURSE_VIEW.GET_ACTIVE_LESSONS_SUCCESS';
export const GET_ACTIVE_LESSONS_ERROR = 'LAB.COURSE_VIEW.GET_ACTIVE_LESSONS_ERROR';

export const GET_ASSIGNED_LESSONS_REQUEST = 'LAB.COURSE_VIEW.GET_ASSIGNED_LESSONS_REQUEST';
export const GET_ASSIGNED_LESSONS_SUCCESS = 'LAB.COURSE_VIEW.GET_ASSIGNED_LESSONS_SUCCESS';
export const GET_ASSIGNED_LESSONS_ERROR = 'LAB.COURSE_VIEW.GET_ASSIGNED_LESSONS_ERROR';

export const CLEAR_LESSONS = 'LAB.COURSE_VIEW.CLEAR_LESSONS';

export const CLOSE_LESSON_MODAL = 'LAB.COURSE_VIEW.CLOSE_LESSON_MODAL';

export const MARK_CLESSON_AS_READ = 'LAB.COURSE_VIEW.MARK_CLESSON_AS_READ';

export const GET_CLESSON_REACTIONS = 'LAB.COURSE_VIEW.GET_CLESSON_REACTIONS';
